import React  from 'react'
import LevelService from '../Services/levelService';
import ErrorMessage from './ErrorMessage';


class LevelComponent extends React.Component 
{

    static defaultProps={
        levelId:null,
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            levelName:"",
        };
    }

    componentDidMount() 
    {
        this.populateName();
    }

    componentDidUpdate(nextProps)
    {
        if(this.props.levelId!==nextProps.levelId)
        {
            this.populateName();
        }
    }

    populateName ()
    {
        if(!this.props.levelId) return null;
        LevelService.GetLevelById(this.props.levelId)
        .then(result => this.setState({levelName:result.name}))
        .catch(() => ErrorMessage.SetErrorMessage("LC39"));
    }

    render()
    {
        
        return (<div>{this.state.levelName}</div>);
    }
}


export default LevelComponent;
